<div class="nk-toast-container" [@listAnimation]="activeToasts.length">
  @for (toast of activeToasts; track toast) {
    <div class="toast show mb-4" role="alert" aria-live="assertive" aria-atomic="true">
      <div class="toast-header">
        <i class="fa fa-circle me-2" [ngClass]="toastColors[toast.type]"></i>
        <strong class="me-auto">{{ toast.title ? toast.title : '' }}</strong>
        <small>{{ toast.timestamp | date: dateFormats.Time }}</small>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="toast"
          aria-label="Close"
          (click)="hideToast(toast.id)"></button>
      </div>
      <div class="toast-body">
        {{ toast.body }}
      </div>
    </div>
  }
</div>
